import axios from 'axios';

const API_URL = 'https://backend.gouniquejourneys.co.uk/api/notifications';
const API_BASE_URL = 'https://backend.gouniquejourneys.co.uk/api/employee/notifications';

export const getNotifications = async (role) => {
  try {
    const response = await axios.get(`${API_URL}/get-notification/${role}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error.response?.data || error.message);
    throw error;
  }
};

// Function to delete all notifications for the logged-in employee
export const deleteAllNotifications = async () => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/clear-all`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting notifications:', error);
    throw error.response?.data || error.message;
  }
};

// Function to delete a specific notification by ID
export const deleteNotificationById = async (notificationId) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/delete-notification/${notificationId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting notification:', error);
    throw error.response?.data || error.message;
  }
};
